export type { Config } from '@/workflow/_contract/config';
export type { CosmosDataModel, CosmosDataExtra } from '@/workflow/_contract/cosmosData';
export { buildCosmosData } from '@/workflow/_pure/cosmosData';
export { getResourceTypeInputSpec } from '@/workflow/_pure/resourceTypeInputSpec';
export { SPACE_SLUG, SPACE_KEY } from '@/workflow/spaceIdentity';
export {
    spaceAdapter,
    DESCRIPTOR,
    type AdapterDescriptor,
} from '@/workflow/registryInput';
